import React from 'react';
import { Typography, Card, Switch, Form, Input, Button, message, Space, Layout } from 'antd';
import { SaveOutlined, SettingOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Content } = Layout;

export const GeneralSettings: React.FC = () => {
  const [form] = Form.useForm();

  const handleSave = async (values: any) => {
    try {
      // TODO: Implement general settings save
      message.success('General settings saved successfully');
    } catch (error) {
      message.error('Failed to save general settings');
    }
  };

  return (
    <Content style={{ padding: '24px' }}>
      <Title level={2}>
        <SettingOutlined style={{ marginRight: '8px' }} />
        General Settings
      </Title>
      <Text type="secondary">Configure general system settings</Text>
      
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        style={{ marginTop: '24px' }}
      >
        <Card title="System Preferences" style={{ marginBottom: '24px' }}>
          <Form.Item
            name="auto_backup"
            label="Automatic Backup"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          
          <Form.Item
            name="email_notifications"
            label="Email Notifications"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          
          <Form.Item
            name="low_stock_alerts"
            label="Low Stock Alerts"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Card>

        <Card title="Display Settings" style={{ marginBottom: '24px' }}>
          <Form.Item
            name="date_format"
            label="Date Format"
            initialValue="YYYY-MM-DD"
          >
            <Input placeholder="YYYY-MM-DD" />
          </Form.Item>
          
          <Form.Item
            name="time_format"
            label="Time Format"
            initialValue="24"
          >
            <Input placeholder="24" />
          </Form.Item>
        </Card>

        <Space>
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
            Save Settings
          </Button>
          <Button onClick={() => form.resetFields()}>
            Reset
          </Button>
        </Space>
      </Form>
    </Content>
  );
};
